var _rect, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimesheet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.3333333333333333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-sheet-icon lucide-sheet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    rx: 2,
    ry: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 21,
    y1: 9,
    y2: 9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 21,
    y1: 15,
    y2: 15
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    x2: 9,
    y1: 9,
    y2: 21
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 15,
    y1: 9,
    y2: 21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheet);
export default __webpack_public_path__ + "static/media/timesheet.4b5c2d4b88e35e5c120a9df77257dd92.svg";
export { ForwardRef as ReactComponent };